import { Stack } from '@chakra-ui/react'

export default function WideCardWithBezel({
  children,
  clickable,
}: {
  children: React.ReactNode
  clickable?: boolean
}): React.ReactElement {
  return (
    <Stack
      justify="space-between"
      spacing={2}
      bg="bg"
      p={6}
      direction="row"
      borderRadius="8px"
      border="2px solid"
      borderLeft="8px solid"
      borderColor="border"
      width="100%"
      cursor={clickable === true ? 'pointer' : undefined}
      _hover={
        clickable === true
          ? {
              bgColor: 'primary.subtle',
              borderColor: 'primary.border',
            }
          : undefined
      }
    >
      {children}
    </Stack>
  )
}
